import pipe from "@insightfulscience/shared-utils/fn/pipe";

// eslint-disable-next-line
const decycle = (obj, stack = []) => {
	if (!obj || typeof obj !== "object") return obj;

	if (stack.includes(obj)) return null;

	const s = stack.concat([obj]);

	return Array.isArray(obj)
		? obj.map(x => decycle(x, s))
		: Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, decycle(v, s)]));
};

const nullTypes = type => object => {
	if (object === null) return object;

	const newObject = Array.isArray(object) ? [...object] : { ...object };

	if (["series", "guides", "plugins"].includes(type)) {
		if ("recommendedVideos" in newObject) {
			newObject.recommendedVideos = newObject.recommendedVideos.map(rv => ({
				...rv,
				fields: {
					...rv.fields,
					recommendedVideos: null,
					body: null,
					contentReference: null,
					additionalResources: null,
				},
			}));
		}

		if ("additionalResources" in newObject) {
			newObject.additionalResources = newObject.additionalResources.map(el => {
				if (el.sys.contentType?.sys.id !== "blockFeaturedContent") return el;

				return {
					...el,
					fields: {
						...el.fields,
						contentReference: el.fields.contentReference?.map(subEl => ({
							...subEl,
							fields: {
								...subEl.fields,
								recommendedVideos: null,
								body: null,
								contentReference: null,
								additionalResources: null,
							},
						})),
					},
				};
			});
		}

		if ("body" in newObject && newObject.body.nodeType === "document") {
			newObject.body.content = newObject.body.content.map(el => ({
				...el,
				content: el.content.map(subEl => {
					if (subEl.nodeType !== "entry-hyperlink") return subEl;

					return {
						...subEl,
						data: {
							...subEl.data,
							target: {
								...subEl.data.target,
								fields: {
									slug: subEl.data.target.fields.slug,
								},
							},
						},
					};
				}),
			}));
		}
	}

	if (type === "standard") {
		if ("contentReference" in newObject) {
			newObject.contentReference = newObject.contentReference.map(el => {
				if (el.sys.contentType?.sys.id !== "blockFeaturedContent") return el;

				return {
					...el,
					fields: {
						...el.fields,
						contentReference: el.fields.contentReference?.map(subEl => ({
							...subEl,
							fields: {
								...subEl.fields,
								recommendedVideos: null,
								body: null,
								contentReference: null,
								additionalResources: null,
							},
						})),
					},
				};
			});
		}
	}

	return newObject;
};

// Temporarily disable decycling, as it's very suboptimal for large page data
export const sanitize = (object, type = null) => pipe(object, nullTypes(type));
